// src/components/LayerPanel/ActiveFooter.jsx
//
// Sticky compact footer — the single global summary of active state now that
// the Active Layers tray is dissolved. Shows the active-layer count and a
// "Clear all" affordance. Both derive from useActiveLayers so the number means
// exactly one thing.

import React from "react";
import useActiveLayers from "./useActiveLayers";

export default function ActiveFooter() {
  const { count, clearAll } = useActiveLayers();

  return (
    <div className="flex-shrink-0 flex items-center gap-2 px-2.5 py-1.5 border-t border-slate-800 bg-bg-softer">
      <span className="text-[10px] text-gray-400 tabular-nums">
        {count} {count === 1 ? "layer" : "layers"} active
      </span>
      <span className="text-gray-700">·</span>
      <button
        type="button"
        onClick={clearAll}
        disabled={count === 0}
        className="text-[10px] text-fg-secondary transition
          hover:text-red-400 disabled:opacity-40 disabled:hover:text-gray-500"
      >
        Clear all
      </button>
    </div>
  );
}
